    //Firebase
    import {useAuthState} from "react-firebase-hooks/auth";
    import {auth} from "../firebase";

    //React imports
    import React from "react";
    import {useParams} from "react-router-dom";
    import {useState} from 'react';
    // import {makeStyles} from '@mui/styles';
    import Grid from "@material-ui/core/Grid";
    import {Container, Paper} from "@mui/material";
    import Button from "@mui/material/Button";
    // import Hidden from "@mui/material/Hidden";
    import LazyLoad from "react-lazyload";
    import Helmet from "react-helmet";
    import Slider from "react-slick";

    //Components
    import {Square} from "../global/components/Square";
    import CenterGrid from "../CenterGrid.js";
    import ShippingFooter from "../ShippingFooter/ShippingFooter.js";
    import {CustomButton} from "../styledComponents.js";
    import { useStyles_LandingPage as useStyles, useStyles2_LandingPage, buttonStyles, bodyStyle } from "./useStyles_LandingPage.js";
    import {landingSlider, home_slider_settings as slider_settings} from "../data/homeSliderData";
    import GlobalBanner from "../GlobalBanner";
    import GlobalBannerAccordion from "../GlobalBannerAccordion";

    //Hooks, utils, data
    import {ProductPrice} from "./functions_LandingPage.js";
    import productData from "../data/productData.js";
    import {DebugContainer} from "../Debug/Debug";
    import {getPageData, SeoComponent, StructureDebug} from "../structure/jigpawsStructure";


    function Slide(props) {
        const classes = useStyles2_LandingPage();

        return (
            <LazyLoad height={200} once>
                <Paper elevation={0} square={true} className={classes.jigpaws}>
                    <img className={classes.fullWidth} src={props.item.src} alt=""/>
                </Paper>
            </LazyLoad>
        );
    }


    const LandingPage = () => {
        const classes = useStyles();
        const classes2 = useStyles2_LandingPage();
        const [user, authLoading, authError] = useAuthState(auth);
        const {productType} = useParams();
        const data = productData[productType];
        //splits url into categories to get data
        const [category, ...productParts] = productType.split('-');
        const product = productParts.join('-');
        const pageData = getPageData({
        pageType: "Product-Landing",
        category: category.toLowerCase(),
        product: product.toLowerCase()
        });
        // const pageData = getPageData({ pageType: "Product-Landing", category: data.constant.type.toLowerCase() });

        // accordion
        const [isActive, setIsActive] = useState(false);
        //BoldText
       const parseBoldText = (text) => {
         // Ensure text is not undefined
        if (!text) return null;

        // Banner Date

      // Split text by '**' to isolate bold sections
      const parts = text.split(/(\*\*.*?\*\*)/);
      return parts.map((part, index) =>
        part.startsWith("**") && part.endsWith("**") ? (
          // Render text inside ** as <strong>
          <strong key={index}>{part.slice(2, -2)}</strong>
        ) : (
          part // Just render text without modification
        )
      );
    };

        return <>
            {/*<Helmet>*/}
            {/*    <title>{data.head.title}</title>*/}
            {/*    <meta name="description" content={pageData.meta.description}/>*/}
            {/*    <meta property="og:url" content={data.meta.og_url}/>*/}
            {/*    <meta property="og:type" content="article"/>*/}
            {/*    <meta property="og:title" content={data.meta.og_title}/>*/}
            {/*    <meta property="og:description" content={data.meta.og_description}/>*/}
            {/*    <meta property="og:image" content={data.meta.og_image}/>*/}
            {/*</Helmet>*/}
                        <SeoComponent page={pageData} />

                <Container
                className={"productsHome bgRed"}
                            align="center"
                            disableGutters={true}
                            maxWidth={false}
                        >
                <GlobalBannerAccordion/>
            </Container>
            <DebugContainer><StructureDebug pageData={pageData}/></DebugContainer>
            <Container className={"productsHome bgGray"} align="center" disableGutters={true}
                       maxWidth={false}>
                <div className="spacer"/>
                <div className="headerContainer">
                    <div><h1>{pageData.content.h1}</h1></div>
                    <div className="spacerSmall"/>
                    <div className="body leader">{data.header.description}</div>
                    {data.header.description2 && <>
                        <div className="spacerSmall"/>
                        <div className="body leader">{data.header.description2}
                        </div>
                    </>}
                </div>
                <div className="spacer"/>
                <GlobalBanner/>

                {/*<div className="jpDivider bgBlue"/>*/}
            </Container>

            {!data.banner || new Date() > new Date('2024-12-25') ? (
                <div/>
            ) : (
                <Container
                    className={"productsHome bgRed"}
                    align="center"
                            disableGutters={true}
                            maxWidth={false}
                        >
                            <div className="accordion bgRed">
                                <div
                                    className="accordionTop accordionCenter bgRed"
                                    onClick={() => setIsActive(!isActive)}
                                >
                                    <h2>{data.banner.sectionTitle}</h2>
                                    <div className="accordion-title bgRed">
                                        <div className="accordionButton">{isActive ? '-' : '+'}</div>
                                    </div>
                                </div>
                                <div
                                    className={`accordionContent bgRed ${
                                        isActive ? "open" : "closed"
                                    }`}
                                >
                                    {/*<div className="spacer"/>*/}
                                    <p>{parseBoldText(data.banner.description)}</p>
                                    {data.banner.items.map((item, index) => (
                                        <div key={index} className="accordionSection jPDynamic">
                                            <h3>{item.title}</h3>
                                            <div className="spacerSmall"/>
                                            <p>{parseBoldText(item.description)}</p>
                                            {item.list && (
                                                <>
                                                    <div className="spacerMed"/>
                                                    <div className="dottedList">
                                                        {item.list}
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                    ))}
                                       <Button style={buttonStyles} size="large" variant="outlined" href="/deliveries-and-returns">Read more about delivery</Button>
                                    <div className="spacer"/>

                                </div>
                            </div>
                        </Container>
            )}
            <Container maxWidth="xxl" disableGutters={true} spacing={0}>
                <Grid container spacing={0} className="marginBottomFix">
                    <Grid item xs={12} md={6} order={{xs: 2, sm: 2}} className={classes.moveToFront}>
                        <square>
                            <img className="jpLine" src={data.panel_1.image.src}
                                 alt={data.panel_1.image.alt} style={{"width": "100%"}}/>
                        </square>
                    </Grid>
                    <Grid item xs={12} md={6} className="jpTile bgWhite" order={{xs: 1, sm: 1}}>
                        <Square>
                            <CenterGrid>
                                <Grid>
                                    <div className="jpTileInner jPDynamic">
                                        <h2>{data.panel_1.title}</h2>
                                        <div className="spacerMed"/>
                                        <div className="body">
                                            <p>{data.panel_1.description}</p>
                                            <div className="spacerSmall"/>
                                        </div>
                                        <div className="spacerSmall"/>
                                        <ProductPrice user={user} productId={data.consistent.price}
                                                      startingFrom={data.consistent.priceFrom}></ProductPrice>
                                        <div className="spacerMed"/>
                                        <Button size="small" variant="outlined" sx={buttonStyles}
                                                href={data.consistent.createLink}>CREATE NOW</Button>
                                    </div>
                                    <div className="productPriceDisclaimer"/>
                                    <div className="spacerMed"/>
                                </Grid>
                            </CenterGrid>
                        </Square>
                    </Grid>
                </Grid>
                {/*<div className="spacerMed"/>*/}
                <Grid container spacing={0} className="marginBottomFix">
                    <Grid item xs={12} md={6} className="jpTile bgWhite">
                        <Square>
                            <CenterGrid>
                                <Grid>
                                    <div className="jpTileInner jPDynamic">
                                        <h2>{data.panel_2.title}</h2>
                                        <div className="spacerMed"/>
                                        <div className="body">
                                            <p>{data.panel_2.description}</p>
                                            <div className="spacerSmall"/>
                                            <p>{data.panel_2.description2}</p>
                                        </div>
                                        <div className="spacerMed"/>
                                        <Button size="small" variant="outlined" sx={buttonStyles}
                                                href={data.consistent.createLink}>CREATE NOW</Button>

                                    </div>
                                    <div className="productPriceDisclaimer"/>
                                    <div className="spacerMed"/>
                                </Grid>
                            </CenterGrid>
                        </Square>
                    </Grid>
                    <Grid item xs={12} md={6} className={classes.moveToFront}>
                        <square>
                            <img className="jpLine" src={data.panel_2.image.src}
                                 alt={data.panel_2.image.alt} style={{"width": "100%"}}/>
                        </square>
                    </Grid>
                </Grid>
                <Grid container spacing={0} className="marginBottomFix">
                    <Grid item xs={12} md={6} className={classes.moveToFront}>
                        <square>
                            <img className="jpLine" src={data.panel_3.image.src}
                                 alt={data.panel_3.image.alt} style={{"width": "100%"}}/>
                        </square>
                    </Grid>
                    <Grid item xs={12} md={6} className="jpTile bgWhite">
                        <Square>
                            <CenterGrid>
                                <Grid>
                                    <div className="jpTileInner jPDynamic">
                                        <h2>{data.panel_3.title}</h2>
                                        <div className="spacerMed"/>
                                        <div className="body">
                                            <p>{data.panel_3.description}</p>
                                            <p>{data.panel_3.description2}</p>
                                            <div className="spacerSmall"/>
                                            <div className="dottedList">{data.panel_3.list}</div>
                                        </div>
                                    </div>
                                    <div className="productPriceDisclaimer"/>
                                    <div className="spacerMed"/>
                                </Grid>
                            </CenterGrid></Square>
                    </Grid>

                </Grid>
                {/*<Grid>CUSHIONS</Grid>*/}
                <Grid container spacing={0} className="marginBottomFix">
                    <Grid item xs={12} md={6} className="jpTile bgWhite">
                        <Square>
                            <CenterGrid>
                                <Grid>
                                    <div className="jpTileInner jPDynamic">
                                        <h2>{data.panel_4.title}</h2>
                                        <div className="spacerMed"/>
                                        <div className="body">
                                            <p>{data.panel_4.description}</p>
                                            <div className="spacerSmall"/>
                                            <p>{data.panel_4.description2}</p>
                                            <div className="spacerSmall"/>
                                            <div className="dottedList">{data.panel_4.list}</div>

                                        </div>
                                        {/* <div className="spacerSmall"/> */}
                                        {/* <ProductPrice user={user} productId={"photo-tile"}></ProductPrice> */}

                                        <div className="spacerMed"/>
                                        <Button size="small" variant="outlined" sx={buttonStyles}
                                                href={data.consistent.createLink}>CREATE NOW</Button>
                                    </div>
                                    <div className="productPriceDisclaimer"/>
                                    <div className="spacerMed"/>
                                </Grid>
                            </CenterGrid>
                        </Square>
                    </Grid>

                    <Grid item xs={12} md={6} className={classes.moveToFront}>
                        <Square>
                            <img className={!data.signOff ? "" : ""} src={data.panel_4.image.src}
                                 alt={data.panel_4.image.alt} style={{"width": "100%"}}/>
                        </Square>
                    </Grid>
                </Grid>
            </Container>


            {data.signOffSlider && (
                <>
                    <Container maxWidth="xxl" disableGutters={true} spacing={0}>
                        <Grid container spacing={0} className="marginBottomFix">
                            <Grid item xs={12} md={6} className={classes2.moveToFront}>

                                <Square>
                                    <div className="mobileNone">
                                        {/* <img className="jpLine" src="/images/Homepage2023/JP_Home_Hero_1.webp" width="100%" alt="Jigpaws customised cat puzzle and can"/> */}
                                        <Slider {...slider_settings}>
                                            {
                                                landingSlider.map((item, i) => <Slide key={i} item={item}/>)
                                            }
                                        </Slider>
                                    </div>
                                    <div className="desktopNone">
                                        <img className="jpLine" src="/images/Homepage2023/JP_Home_Hero_1.webp" width="100%"
                                             alt="Jigpaws customised cat puzzle and can"/>
                                    </div>
                                </Square>
                            </Grid>
                            <Grid item xs={12} md={6} className="jpTile bgWhite">
                                <Square>
                                    <CenterGrid>
                                        <Grid>
                                            <div className="jpTileInner jPDynamic">
                                                <h2>{data.signOffSlider.title}</h2>
                                                <div className="spacerMed"/>
                                                <div className="body">
                                                    <p>{data.signOffSlider.description}</p>
                                                    <p>{data.signOffSlider.description2}</p>
                                                    <div className="spacerSmall"/>
                                                    <div className="dottedList">{data.signOffSlider.list}</div>
                                                </div>
                                            </div>
                                            <div className="productPriceDisclaimer"/>
                                            <div className="spacerMed"/>
                                        </Grid>
                                    </CenterGrid>
                                </Square>
                            </Grid>
                        </Grid>
                    </Container>

                </>
            )}
            {data.signOff && (
                <Container
                    className={"productsHome bgGreen"}
                    align="center"
                    disableGutters={true}
                    maxWidth={false}
                >
                    <div className="spacer"/>
                    <div className="headerContainer">
                        <div><h1>{data.signOff.title}</h1></div>
                        <div className="body leader" style={bodyStyle}>{data.signOff.description}
                        </div>
                        <div className="spacer"/>
                        <CustomButton type={"smallwhite"} href={data.consistent.createLink}>CREATE NOW</CustomButton>

                        {data.signOff.description2 && <>
                            <div className="spacerSmall"/>
                            <div className="body leader" style={bodyStyle}>
                                {data.signOff.description2}
                            </div>
                        </>
                        }

                    </div>
                    <div className="spacer"/>
                </Container>
            )}
            {/*ACCORDION*/}
                    {data.faq && (
                        <Container
                            className={"productsHome bgGreen"}
                            align="center"
                            disableGutters={true}
                            maxWidth={false}
                        >
                            <div className="accordion">
                                <div
                                    className="accordionTop"
                                    onClick={() => setIsActive(!isActive)}
                                >
                                    <h2>{data.faq.sectionTitle}</h2>
                                    <div className="accordion-title">
                                        <div className="accordionButton">{isActive ? '-' : '+'}</div>
                                    </div>
                                </div>
                                    <div
                                        className={`accordionContent bgWhite leftText ${
                                            isActive ? "open" : "closed"
                                        }`}
                                    >
                                        <div className="spacer"/>
                                        {data.faq.items.map((item, index) => (
                                            <div key={index} className="accordionSection jPDynamic">
                                                <h3>{item.title}</h3>
                                                <div className="spacerSmall"/>

                                                <p>{item.description}</p>
                                                {item.list && (
                                                    <>
                                                        <div className="spacerMed"/>
                                                        <div className="dottedList">
                                                            {item.list}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                        <div className="spacer"/>
                                    </div>
                            </div>
                        </Container>
                    )}

            <ShippingFooter international={true}/>


        </>;
    };

    export default LandingPage
